import React, { useState } from 'react'
import { css, StyleSheet } from 'aphrodite'
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from 'reactflow'
import { AppTheme } from '../../../../styles/AppTheme'

export function ChatbotDeletableEdge(props) {
  const [hovered, setHovered] = useState(false)
  const edgePathAndLabel = getBezierPath({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    sourcePosition: props.sourcePosition,
    targetX: props.targetX,
    targetY: props.targetY,
    targetPosition: props.targetPosition,
  })
  const edgePath = edgePathAndLabel[0]
  const labelX = edgePathAndLabel[1]
  const labelY = edgePathAndLabel[2]
  const onDelete = props.data && props.data.onDelete
  const showDelete = hovered || !!props.selected
  return (
    <React.Fragment>
      <BaseEdge path={edgePath} markerEnd={props.markerEnd} style={props.style} interactionWidth={24} />
      <path
        d={edgePath}
        fill='none'
        stroke='transparent'
        strokeWidth={24}
        className='react-flow__edge-interaction'
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      />
      <EdgeLabelRenderer>
        <div
          className={'nodrag nopan ' + css(Styles.deleteWrap)}
          style={{
            transform: 'translate(-50%, -50%) translate(' + labelX + 'px,' + labelY + 'px)',
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <button
            type='button'
            tabIndex={showDelete ? 0 : -1}
            className={css(Styles.deleteBtn, showDelete && Styles.deleteBtnVisible)}
            onClick={(e) => {
              e.stopPropagation()
              if (onDelete) onDelete(props.id)
            }}
          >
            <i className={'material-icons-outlined ' + css(Styles.deleteIcon)}>close</i>
          </button>
        </div>
      </EdgeLabelRenderer>
    </React.Fragment>
  )
}

const Styles = StyleSheet.create({
  deleteWrap: {
    position: 'absolute',
    pointerEvents: 'all',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteBtn: {
    width: 20,
    height: 20,
    borderRadius: 10,
    border: '1px solid ' + AppTheme.primaryColor,
    backgroundColor: AppTheme.secondaryBg,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    opacity: 0,
    pointerEvents: 'none',
  },
  deleteBtnVisible: {
    opacity: 1,
    pointerEvents: 'all',
  },
  deleteIcon: {
    fontSize: 14,
    color: AppTheme.primaryColor,
  },
})
